<template>
  <select :data-vv-as="field.description.replace(/\./g, '')"
          class="form-control"
          :id="field.name"
          :name="field.name"
          v-validate="'required'"
          :disabled="locked"
          @change="$emit('input', $event.target.value)">
    <option value="" selected>Select option...</option>
    <option v-for="option in referralDestinationAccounts" :value="option">
      {{ option }}
    </option>
  </select>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: false
    },
    field: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    },
    referralDestinationAccounts: {
      type: Array,
      default: () => [],
    },
  },

  emits: ['input'],

  setup() {}
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// DestinationAccountRender.vue?4bf2f470